import { useNativePostAuth } from '@hooks/useNativePostAuth';

/**
 * Render-less component that activates native post-auth redirect logic.
 * Mounted in RootLayout only on native platforms.
 */
export function NativePostAuthHandler() {
  useNativePostAuth();
  return null;
}
